import { Api } from '@monorepo/shared/apiClient';
import { MutationConfig, useMutation } from 'react-query';

type Input = {
  config?: MutationConfig<Api.GenerateFormTemplateResponse, Api.ErrorResponse>;
};

export function useStartGeneratingFormTemplate(input?: Input) {
  return useMutation(Api.generateFormTemplate, input?.config);
}
